import { connect, MapStateToProps } from "react-redux";

import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { getActiveSubmenuIds } from "../../selectors";
import { SubmenuListComponentProps } from "../SubmenuListComponent";

const mapStateToProps: MapStateToProps<SubmenuListComponentProps, NoneOwnProps, IAppState> = (state) => ({
    submenuIds: getActiveSubmenuIds(state),
});

/**
 * Získá id všech submenu, která mají být zobrazená.
 */
export const SubmenuList = connect(mapStateToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.SubmenuListComponent));
